import { VStack } from "@chakra-ui/react";
import { useAssetsForMap } from "../hooks/useAssetsForMap";
import AlertsBanner from "../components/map/AlertsBanner";
import AlertsMapView from "../components/map/AlertsMapView";
import CascadingAlertFilters from "../components/CascadingAlertFilters";

function AlertsMap() {
  const {
    assets,
    mapBounds,
    headlines,
    filterOptions,
    loading,
    isRefetching,
    error,
    filters,
    setFilters,
    refetch,
  } = useAssetsForMap();

  return (
    <VStack height="calc(100vh - 145px)" gap={0}>
      {/* Alert Summary Banner */}
      <AlertsBanner headlines={headlines} loading={loading} />

      {/* Filters */}
      <CascadingAlertFilters
        filters={filters}
        filterOptions={filterOptions}
        onFiltersChange={setFilters}
        isRefetching={isRefetching}
      />

      {/* Map */}
      <AlertsMapView
        assets={assets}
        mapBounds={mapBounds}
        loading={loading}
        isRefetching={isRefetching}
        error={error ? error.message : undefined}
        onRetry={refetch}
      />
    </VStack>
  );
}

export default AlertsMap;
